import type {
    ReactElement
} from "react";
import {
    Platform
} from "react-native";
import stylesheet from "./stylesheet";
import type ITextProps from "../../components/text/type";
import Text from "../../components/text";

export type AccessibleTextConstantType = ITextProps & {
    label?: string;
};

export const renderAccessibleText = ({
    customTheme,
    children,
    label,
    ...props
}: AccessibleTextConstantType): ReactElement => {
    if(!label) {
        return <Text
            customTheme={customTheme}
            {...props}
        >
            {children}
        </Text>;
    }

    if(Platform.OS !== "web") {
        return <Text
            accessibilityLabel={label}
            customTheme={customTheme}
            {...props}
        >
            {children}
        </Text>;
    }

    return <>
        <Text
            customTheme={customTheme}
            aria-hidden={true}
            {...props}
        >
            {children}
        </Text>
        <Text
            style={stylesheet.hidden}
            customTheme={customTheme}
        >
            {label}
        </Text>
    </>;
};
